import * as React from "react";
import { Tooltip, StatusIcon } from "components/common";
import PreviewInternalLakeLogsButton from "data-lake/components/PreviewInternalLakeLogsButton";
import useFeature from "hooks/useFeature";
import useStreamDataLakeEnabledStatus from "data-lake/hooks/useStreamDataLakeEnabledStatus";
const DataLakeCell = ({ stream }) => {
  const { data: enabled, isFetching } = useStreamDataLakeEnabledStatus(stream.id);
  const previewFeatureIsEnabled = useFeature("data_lake_search");
  if (!stream.is_editable || isFetching) {
    return null;
  }
  const isDataLakeEnabled = enabled || false;
  if (previewFeatureIsEnabled && isDataLakeEnabled) {
    return /* @__PURE__ */ React.createElement(PreviewInternalLakeLogsButton, { streamId: stream.id });
  }
  if (!isDataLakeEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "right", label: "Data lake is enabled" }, /* @__PURE__ */ React.createElement(StatusIcon, { active: true }));
};
export default DataLakeCell;
